import React, { ReactElement } from 'react';
import {
  Card,
  Colors,
  CardCaption,
  CardContainer,
  getRadius,
  getSpacing,
  ButtonBase,
  Rating,
  Text,
  Image,
} from '@rahtab/ui';
import { ImageProps, Platform, StyleSheet, View } from 'react-native';
import LocationIcon from '@rahtab/ui/dist/icons/LocationIcon';
import ChevronLeftIcon from '@rahtab/ui/dist/icons/ChevronLeftIcon';

const defaultProvider = require('../../assets/images/defaultProvider.png');

const StoreItem: React.FC<ItemBaseProps> = ({
  name,
  image,
  county,
  city,
  onPress,
  linkUrl,
  screenName,
  params,
  fullName,
}) => {
  return (
    <ButtonBase to={linkUrl} onPress={onPress} screenName={screenName} params={params}>
      <Card style={styles.card}>
        <CardContainer>
          <View style={styles.innerView}>
            <Image
              style={styles.image}
              variant="outlined"
              resizeMode="cover"
              defaultSource={defaultProvider}
              source={image}
            />
            <View style={styles.details}>
              <Text variant="title" color="primary" numberOfLines={1} margin="none">
                {name}
              </Text>
              <Text variant="cardTitle" color="primary" numberOfLines={1} margin="none">
                {fullName}
              </Text>
              <View style={styles.textAndIcon}>
                <LocationIcon style={styles.mapMarker} />
                <Text margin="none">
                  {county} | {city}
                </Text>
              </View>
            </View>
          </View>
        </CardContainer>
      </Card>
    </ButtonBase>
  );
};
export default StoreItem;

const styles = StyleSheet.create({
  innerView: {
    flexDirection: 'row',
  },
  card: {
    marginHorizontal: getSpacing(),
    marginVertical: getSpacing(0.5),
  },
  image: {
    height: 80,
    width: 80,
    borderRadius: getRadius(),
  },
  details: {
    marginLeft: getSpacing(),
    width: '65%',
    justifyContent: 'space-between',
  },
  textAndIcon: {
    flexDirection: 'row',
  },
  mapMarker: {
    marginRight: getSpacing(0.35),
    marginTop: Platform.OS === 'web' ? 0 : getSpacing(0.3),
  },
  caption: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

interface ItemBaseProps {
  id: string;
  image: ImageProps['source'];
  city?: string;
  name?: string;
  county?: string;
  linkUrl?: string;
  screenName?: string;
  params?: any;
  onPress?: () => void;
  fullName?: string;
}
